import { jsx as _jsx } from "react/jsx-runtime";
// @flow
import { useMemo } from 'react';
import { BreakdownTable } from 'app/pages/Project/Breakdown/BreakdownTable.jsx';
import getProjectIdFromURL from 'app/core/utils/getProjectIdFromURL';
import { permission } from 'app/containers/Permissions';
import classes from './Breakdown.module.scss';
export default function (props) {
    const { asset } = props;
    const projectId = (asset === null || asset === void 0 ? void 0 : asset.project) || getProjectIdFromURL();
    const resourcesParams = useMemo(() => asset
        ? {
            resourceType: 'assets',
            requestName: 'fetchOne',
            headers: { [window.OVM_PROJECT_HEADER]: asset.project || '' },
            includedResources: [
                'assetLinksInst.to_assetInst',
                'assetFlagsInst',
                'assetFlagsInst.flagInst',
                'thumbnailInst',
            ],
            requestData: asset.id,
        }
        : undefined, [asset]);
    if (!projectId) {
        return (_jsx("div", { className: "fullWidth fullHeight flex center alignCenter lightgrey", style: { padding: 10, fontSize: 14 }, children: `You have to be in the ${(asset === null || asset === void 0 ? void 0 : asset.name) || ''} project to be able to see the breakdown` }));
    }
    if (projectId && !permission(['projet_breakdown__read'], undefined, undefined, projectId)) {
        return (_jsx("div", { className: "fullWidth fullHeight flex center alignCenter lightgrey", style: { padding: 10, fontSize: 14 }, children: `You don't have permission to see the breakdown table.` }));
    }
    return (_jsx("div", { className: classes.table, children: _jsx(BreakdownTable, { tableId: "assetBreakdownEpisode", enableEdit: permission(['projet_breakdown_links_create']), parentAssetId: asset === null || asset === void 0 ? void 0 : asset.id, projectId: projectId, resourcesParams: resourcesParams }) }));
}
